'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = function (node, event, handler, capture) {
  (0, _on2["default"])(node, event, handler, capture);

  return {
    remove: function remove() {
      (0, _off2["default"])(node, event, handler, capture);
    }
  };
};

var _on = require('dom-helpers/events/on');

var _on2 = _interopRequireDefault(_on);

var _off = require('dom-helpers/events/off');

var _off2 = _interopRequireDefault(_off);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/bee-overlay/build/utils/addEventListener.js
// module id = 75
// module chunks = 0